import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { jobConfig } from '@modules/job-page/job.config';
import { JobEditResolver } from './containers/page/job-edit-page.resolver';

import { JobFormSelectResolver } from './job-form-select.resolver';
import { ResolveCloneResolver } from './resolve-clone.resolver';
import { JobEditPageComponent } from '@shared/job-form/containers/page/job-edit-page.component';
import { JobFormGuard } from '@shared/job-form/guards/job-form.guard';

export const modalRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'create',
        component: JobEditPageComponent,
        resolve: [JobEditResolver],
        data: {
          privilege: jobConfig.privileges.job.edit,
        },
        canActivate: [JobFormGuard],
        canDeactivate: [JobFormGuard],
      },
      {
        path: ':id',
        component: JobEditPageComponent,
        resolve: [JobFormSelectResolver],
        data: {
          privilege: jobConfig.privileges.job.edit,
        },
        canActivate: [JobFormGuard],
        canDeactivate: [JobFormGuard],
      },
      {
        path: 'clone/:id',
        component: JobEditPageComponent,
        resolve: [ResolveCloneResolver],
        data: {
          privilege: jobConfig.privileges.job.edit,
        },
        canActivate: [JobFormGuard],
        canDeactivate: [JobFormGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(modalRoutes)],
  exports: [RouterModule],
  providers: [JobFormSelectResolver],
})
export class JobFormRoutingModule {}
